import React from "react";
import BottomBar_mobile from "./mobile";
import BottomBar_desktop from "./desktop";

export default function BottomBar({isMobile, ...props}) {
	const Component = isMobile ? BottomBar_mobile : BottomBar_desktop;
	return <Component {...props} />;
}
